import { createGlobalStyle } from 'styled-components';
import { theme } from '../styles/theme';
const { mainColor, secondaryColor, rbmWhite, rbmBlack } = theme.colors;
export const GlobalStyles = createGlobalStyle`
  * {
    margin:0;
    padding:0;
    font-family: Poppins, sans-serif;
    font-size: 1vw;

  }
  input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}

.swal2-popup.swal2-loading{
    grid-template-columns: auto auto;
    width: 500px;
}
  //z-index setado para ficar acima de todos os modais da aplicação
  .swal2-container{
    z-index:2000;
  }
.swal2-loader{ border-color:${mainColor} transparent ${mainColor} transparent}
 
.swal2-cancel.swal2-styled {
  background-color: ${rbmWhite};
    width: 12.153vw;
        height: 3.333vw;
        font-size: 0.972vw;
        font-style: normal;
        font-weight: 500;
        line-height: 1.667vw;
        letter-spacing: 0.09vw;
        text-align: center;
        color: ${rbmBlack};
        box-sizing: border-box;
        border-radius: 4px;

        :hover{
      background-color: ${secondaryColor};
      color: ${rbmWhite};    
        }
}
     .swal2-styled.swal2-confirm,.swal2-deny.swal2-styled  {
        background-color: ${secondaryColor};
        width: 12.153vw;
        height: 3.333vw;
        font-size: 0.972vw;
        font-style: normal;
        font-weight: 500;
        line-height: 1.667vw;
        letter-spacing: 0.09vw;
        text-align: center;
        color: ${rbmWhite};
        box-sizing: border-box;
        border-radius: 4px;

        :hover{
      background-color: ${mainColor};
      color: ${rbmBlack};    
        }
      }
button > svg.default-svg{
  color:${rbmWhite};
}

button > span > svg.default-svg{
  margin-right:1vw;
}



button > svg.default-svg:hover {
 color: ${rbmBlack};
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
border-color:${secondaryColor};
border-width:1px;
}

`;
